<template id="">
  <div>
    <div class="login usr">
      <!--h3><img class="logo" src="@/img/logo.png" alt="インテリジェントヘルスケア ストレスチェックApp"></h3-->
      <h4 class="common-font">
        {{ $t("displayValue_Respondent.RESULT_ttl_screen") }}
      </h4>
      <div
        class="uk-margin uk-text-large common-font"
        v-show="$store.state.common.sIsLoading"
      >
        Loading...
      </div>
      <div
        v-if="ret_data != null && !$store.state.common.sIsLoading"
        class="common-font"
      >
        <table v-if="ret_data['sc_data'].length > 0" style="margin: auto">
          <tr
            v-for="(item, index) in ret_data['sc_data']"
            :key="item"
            style="height: 25px"
          >
            <td>
              <a :id="index" @click="get_personal_pdf(item.sc_id)"
                >・{{
                  formatImplementationYearMonth({
                    sc_year: item.sc_year,
                    sc_month: item.sc_month,
                  })
                }}</a
              >
            </td>
          </tr>
        </table>
        <p class="large cntr fwb" v-else>
          {{ $t("displayValue_Respondent.RESULT_guide_no_result") }}
        </p>
        <button
          class="
            uk-button uk-button-secondary uk-width-1-1
            common-rounded
            uk-margin-small-top
          "
          type="button"
          @click="$router.back()"
        >
          &lt;&nbsp;{{ $t("displayValue_Respondent.RESULT_btn_back") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      vComId: this.$store.state.common.sComId,
      vEmpCode: this.$store.state.common.sUserCode,
      alias_id: sessionStorage.getItem("storageAliasId"),
      email: sessionStorage.getItem("storageId"),
      pw: sessionStorage.getItem("storagePw"),
      ret_data: null,
    };
  },
  computed: {},
  mounted() {
    this.$store.state.common.sIsLoading = false;
    document.title = this.$t("displayValue_Respondent.RESULT_ttl_doc");
  },
  created() {
    // 画面読み込み中・・・
    this.$store.commit("common/doStartServerProcess");
    this.get_results();
    this.$store.commit("common/doEndServerProcess");
  },
  methods: {
    create_pdf_url(base64Str) {
      const file = new Blob([atob(base64Str)], {
        type: "application/pdf",
      });
      const fileURL = URL.createObjectURL(file);
      window.open(fileURL);
    },
    get_results() {
      let createHash = require("sha256-uint8array").createHash;
      this.pw = createHash().update(this.pw).digest("hex");
      this.$axios
        .post("/get_personal_sc_history", {
          alias_id: this.alias_id,
          email: this.email,
          pw: this.pw,
        })
        .then((response) => {
          if (response.data.flg == true) {
            this.ret_data = response.data;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    get_personal_pdf(sc_id) {
      this.$store.commit("common/doStartServerProcess");
      this.$store.state.common.sIsLoading = true;
      this.$axios
        .post("/get_personal_pdf", {
          emp_code: this.vEmpCode,
          sc_id: sc_id,
          language_type: this.$store.state.common.sLanguageTypeNow,
        })
        .then((response) => {
          this.$store.commit("common/doEndServerProcess");
          this.$store.state.common.sIsLoading = false;
          if (response.data.flg) {
            window.open(
              window.URL.createObjectURL(this.make_blob(response.data.pdf))
            );
          } else {
            // 念のためまだ分析が終わっていないメッセージを表示する
            // （大人数の分析の場合、zipのアップロードを複数回に分ける可能性があるため）
            // 1回目のアップロードでステータスが実施済みになり、結果PDFのリンクが表示されてしまう
            window.alert(
              this.$t("displayValue_Respondent.RESULT_msg_analysis_pdf1") +
                "\n" +
                this.$t("displayValue_Respondent.RESULT_msg_analysis_pdf2")
            );
          }
        })
        .catch((error) => {
          this.$store.commit("common/doEndServerProcess");
          this.$store.state.common.sIsLoading = false;
          console.log(error);
        });
    },
    make_blob(base64_str) {
      let dataURI = "data:application/pdf;base64," + base64_str;
      // "iVBORw..."をバイナリに変換
      var byteString = atob(dataURI.split(",")[1]);

      // "image/png"
      var mimeType = dataURI.match(/(:)([a-z/]+)(;)/)[2];

      // バイナリからBlobを作成
      for (
        var i = 0, l = byteString.length, content = new Uint8Array(l);
        l > i;
        i++
      ) {
        content[i] = byteString.charCodeAt(i);
      }

      var blob = new Blob([content], {
        type: mimeType,
      });
      return blob;
      // window.open(window.URL.createObjectURL( blob )) ;
    },
    // 年月を整形して返す
    formatImplementationYearMonth(pVal) {
      let _return = "";
      _return = this.$t("displayValue_Respondent.RESULT_result_ym")
        .replace("__replace1__", pVal.sc_year)
        .replace("__replace2__", pVal.sc_month);
      return _return;
    },
  },
  watch: {
    // 選択した言語によって日付の表記を整形する
    "$store.state.common.sLanguageTypeNow"(newVal, oldVal) {
      document.title = this.$t("displayValue_Respondent.RESULT_ttl_doc");
      // 実施年月
      this.formatImplementationYearMonth({
        sc_year: this.ret_data.sc_year,
        sc_month: this.ret_data.sc_month,
      });
    },
  },
};
</script>
